import { apiRequest, apiRoutes } from '../../../../api';
import React, { useEffect, useState } from 'react';
import { fetchUserById, updateUserById, searchAddressNominatim } from '../../services/userService';
import MapContainerComponent from '../map/MapContainer';
import '../../Profile.css';

function UserInfoPanel() {
  const userId = localStorage.getItem('user_id');

  const [userInfo, setUserInfo] = useState({
    username: '', email: '', phone: '',
    first_name: '', last_name: '',
    address: '', city: '', province: '', postal_code: '',
    birthdate: '', gender: '', is_married: false,
    national_id: '', adults_count: '', children_count: '', pet: '',
    bio: '', profile_image: null
  });
  const [addressSearchQuery, setAddressSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => { loadUser(); }, []);

  const loadUser = async () => {
    try {
      const data = await fetchUserById(userId);
      setUserInfo(data);
      if (data.profile_image) setImagePreview(data.profile_image);
    } catch (err) {

      setError('خطا در دریافت اطلاعات کاربری');
    }
  };

  const reverseGeocode = async (lat, lng) => {
    try {
      const res = await apiRequest(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1&accept-language=fa`
      );
      const data = await res.json();
      if (data?.address) {
        setUserInfo(prev => ({
          ...prev,
          address: data.display_name || '',
          city: data.address.city || data.address.town || data.address.village || '',
          province: data.address.state || data.address.province || '',
          postal_code: data.address.postcode || ''
        }));
      }
    } catch (err) {

    }
  };

 const handleMapLocationSelect = (latlng) => {
    setPendingLocation(latlng);
  };

  const handleConfirmLocation = async () => {
    if (pendingLocation) {
      await reverseGeocode(pendingLocation[0], pendingLocation[1]);
    }
    setShowMapModal(false);
    setPendingLocation(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    try {
      let payload;
      if (imageFile) {
        // Use FormData when uploading a new image
        const writableFields = [
          'first_name', 'last_name', 'phone', 'national_id',
          'address', 'city', 'province', 'postal_code',
          'birthdate', 'gender', 'is_married',
          'adults_count', 'children_count', 'pet', 'bio'
        ];
        payload = new FormData();
        writableFields.forEach((key) => {
          const val = userInfo[key];
          if (val !== null && val !== undefined && val !== '') {
            payload.append(key, val);
          }
        });
        // send under the write-only field name the serializer expects
        payload.append('upload_profile_image', imageFile);
        const token = localStorage.getItem('access_token');
        const res = await apiRequest(apiRoutes.users.detail(userId), {
          method: 'PUT',
          headers: { Authorization: `Bearer ${token}` },
          body: payload,
        });
        if (!res.ok) throw new Error(await res.text());
        const updated = await res.json();
        setUserInfo(updated);
        if (updated.profile_image) setImagePreview(updated.profile_image);
      } else {
        const updated = await updateUserById(userId, userInfo);
        setUserInfo(updated);
      }
      setImageFile(null);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {

      setError('خطا در ذخیره اطلاعات کاربری');
    }
  };

  const handleAddressSearch = async (query) => {
    setAddressSearchQuery(query);
    try {
      const results = await searchAddressNominatim(query);
      setSearchResults(results);
    } catch (err) {

    }
  };

  const handleAddressSelect = (result) => {
    setUserInfo(prev => ({
      ...prev,
      address: result.display_name,
      city: result.address?.city || result.address?.town || result.address?.village || '',
      province: result.address?.state || result.address?.province || '',
      postal_code: result.address?.postcode || ''
    }));
    setAddressSearchQuery(result.display_name);
    setSearchResults([]);
  };

  const set = (field) => (e) => setUserInfo({ ...userInfo, [field]: e.target.value });

    return (
    <div className="uip">

      {/* Map Modal */}
      {showMapModal && (
        <div className="map-modal-overlay" onClick={(e) => {
          if (e.target.classList.contains('map-modal-overlay')) setShowMapModal(false);
        }}>
          <div className="map-modal">
            <div className="map-modal-header">
              <span>موقعیت خود را روی نقشه انتخاب کنید</span>
              <button className="map-modal-close" onClick={() => setShowMapModal(false)}>✕</button>
            </div>
            <div className="map-modal-body">
              <MapContainerComponent onLocationSelect={handleMapLocationSelect} selectedLocation={pendingLocation} />
            </div>
            <div className="map-modal-footer">
              {pendingLocation && <span className="map-modal-coords">{pendingLocation[0].toFixed(5)}, {pendingLocation[1].toFixed(5)}</span>}
              <button className="primary-btn" onClick={handleConfirmLocation} disabled={!pendingLocation}>تأیید موقعیت</button>
              <button className="btn-secondary" onClick={() => { setShowMapModal(false); setPendingLocation(null); }}>انصراف</button>
            </div>
          </div>
        </div>
      )}

      {/* Header: avatar + title + save button */}
      <div className="uip-header">
        <div className="uip-avatar-wrap">
          <div className="uip-avatar">
            {imagePreview ? <img src={imagePreview} alt="profile" /> : <span>👤</span>}
          </div>
          <label className="uip-avatar-btn" title="تغییر تصویر">
            📷
            <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
          </label>
        </div>
        <div className="uip-title">
          <h3>اطلاعات کاربری</h3>
          {imageFile && <span className="uip-img-hint">تصویر جدید انتخاب شد</span>}
        </div>
        <button type="submit" form="uip-form" className="primary-btn uip-save-btn">ذخیره</button>
      </div>

      {error && <div className="error-banner">{error}</div>}
      {success && <div className="success-banner">ذخیره شد ✓</div>}

      <form id="uip-form" onSubmit={handleSubmit}>

        <div className="uip-section-label">حساب</div>
        <div className="uip-grid">
          <div className="uip-field">
            <label>نام کاربری</label>
            <input type="text" value={userInfo.username || ''} disabled className="input-disabled" />
          </div>
          <div className="uip-field">
            <label>ایمیل</label>
            <input type="email" value={userInfo.email || ''} disabled className="input-disabled" />
          </div>
        </div>

        <div className="uip-section-label">شخصی</div>
        <div className="uip-grid">
          <div className="uip-field">
            <label>نام</label>
            <input type="text" value={userInfo.first_name || ''} onChange={set('first_name')} placeholder="نام" />
          </div>
          <div className="uip-field">
            <label>نام خانوادگی</label>
            <input type="text" value={userInfo.last_name || ''} onChange={set('last_name')} placeholder="نام خانوادگی" />
          </div>
          <div className="uip-field">
            <label>شماره تماس</label>
            <input type="tel" value={userInfo.phone || ''} onChange={set('phone')} placeholder="09xxxxxxxxx" />
          </div>
          <div className="uip-field">
            <label>کد ملی</label>
            <input type="text" value={userInfo.national_id || ''} onChange={set('national_id')} placeholder="۱۰ رقم" />
          </div>
          <div className="uip-field">
            <label>تاریخ تولد</label>
            <input type="date" value={userInfo.birthdate || ''} onChange={set('birthdate')} />
          </div>
          <div className="uip-field">
            <label>جنسیت</label>
            <select value={userInfo.gender || ''} onChange={set('gender')}>
              <option value="">-</option>
              <option value="male">مرد</option>
              <option value="female">زن</option>
            </select>
          </div>
          <div className="uip-field uip-checkbox">
            <label className="checkbox-label">
              <input type="checkbox" checked={userInfo.is_married || false}
                onChange={(e) => setUserInfo({ ...userInfo, is_married: e.target.checked })} />
              متاهل
            </label>
          </div>
        </div>

        <div className="uip-section-label">خانوار</div>
        <div className="uip-grid">
          <div className="uip-field">
            <label>بزرگسالان</label>
            <input type="number" min="0" value={userInfo.adults_count || ''} onChange={set('adults_count')} placeholder="۰" />
          </div>
          <div className="uip-field">
            <label>کودکان</label>
            <input type="number" min="0" value={userInfo.children_count || ''} onChange={set('children_count')} placeholder="۰" />
          </div>
          <div className="uip-field">
            <label>حیوان خانگی</label>
            <select value={userInfo.pet || ''} onChange={set('pet')}>
              <option value="">-</option>
              <option value="cat">گربه</option>
              <option value="dog">سگ</option>
              <option value="bird">پرنده</option>
              <option value="none">ندارم</option>
            </select>
          </div>
        </div>

        <div className="uip-section-label">آدرس</div>
        <div className="uip-grid">
          <div className="uip-field uip-span-2">
            <label>آدرس کامل</label>
            <div className="address-row">
              <input type="text" value={userInfo.address || ''} onChange={set('address')} placeholder="آدرس" />
              <button type="button" className="btn-map-toggle inactive" onClick={() => setShowMapModal(true)}>🗺 نقشه</button>
            </div>
          </div>
          <div className="uip-field uip-span-3">
            <label>جستجوی آدرس</label>
            <input type="text" value={addressSearchQuery}
              onChange={(e) => handleAddressSearch(e.target.value)} placeholder="جستجو..." />
            {searchResults.length > 0 && (
              <div className="address-search-results">
                {searchResults.map((r, i) => (
                  <div key={i} className="address-search-result-item" onClick={() => handleAddressSelect(r)}>
                    {r.display_name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="uip-field">
            <label>شهر</label>
            <input type="text" value={userInfo.city || ''} onChange={set('city')} placeholder="شهر" />
          </div>
          <div className="uip-field">
            <label>استان</label>
            <input type="text" value={userInfo.province || ''} onChange={set('province')} placeholder="استان" />
          </div>
          <div className="uip-field">
            <label>کد پستی</label>
            <input type="text" value={userInfo.postal_code || ''} onChange={set('postal_code')} placeholder="کد پستی" />
          </div>
        </div>

        <div className="uip-section-label">بیوگرافی</div>
        <textarea className="uip-bio" value={userInfo.bio || ''} onChange={set('bio')}
          placeholder="درباره خودتان بنویسید..." />

      </form>
    </div>
  );
}

export default UserInfoPanel;
